import { useLayoutEffect, useRef, useState } from 'react'

import { SequenceCompletion } from '@/webgl/runner/scenarios/SequenceCompletion'

import RunnerGoalDictationItem from './RunnerGoalDictationItem'

export type RunnerGoalDictationProps = {
  completion: SequenceCompletion
}

export default function RunnerGoalDictation({ completion }: RunnerGoalDictationProps) {
  const currentBlock = completion.blocks[completion.currentBlock]
  const currentIndex = currentBlock.collected.length

  const element = useRef<HTMLDivElement>(null)
  const [isSmall, setIsSmall] = useState<boolean>()
  const [isInit, setIsInit] = useState<boolean>()
  const [offset, setOffset] = useState<number>(0)

  useLayoutEffect(() => {
    const onResize = () => {
      const isSmall = window.innerWidth < 768
      setIsSmall(isSmall)
    }
    onResize()
    window.addEventListener('resize', onResize)

    return () => window.removeEventListener('resize', onResize)
  }, [setIsSmall])

  useLayoutEffect(() => {
    let offset = 0
    let timeout = null
    if (isSmall) {
      const gap = 8
      // translate to center the current item
      const items = [...element.current.querySelectorAll('.RunnerGoalDictationItem')] as HTMLElement[]

      let i = 0
      while (i <= currentIndex) {
        const item = items[i] as HTMLElement
        if (i === currentIndex) {
          offset += item.offsetWidth / 2
        } else {
          offset += item.offsetWidth + gap
        }
        i++
      }

      if (currentIndex === 0) {
        timeout = setTimeout(() => {
          setIsInit(true)
        }, 100)
      }
    }
    setOffset(offset)

    return () => {
      clearTimeout(timeout)
    }
  }, [element, isSmall, currentIndex])

  return (
    <div className='pt-20 md:pt-32'>
      {currentBlock.goalText && (
        <p className='text-14 md:text-16 font-semibold text-center pb-12'>{currentBlock.goalText}</p>
      )}
      <div
        ref={element}
        className={`RunnerGoalVariant Runner__goal-dictation relative px-12 md:px-24 flex items-center gap-8 bg-tertiary border-4 border-mid-blue min-h-88 min-w-88 p-8 rounded-24 text-body-l ${isSmall ? 'left-1/2 -ml-16' : ''} ${isInit ? 'transition-transform duration-500 ease-out-quad' : ''}`}
        style={{ transform: `translateX(-${offset}px)` }}
      >
        {currentBlock.goal.map((goal, index) => (
          <RunnerGoalDictationItem
            key={index}
            index={index}
            text={goal}
            collected={currentBlock.collected.includes(goal)}
            searched={index === currentIndex}
          />
        ))}
      </div>
    </div>
  )
}
